import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';
export const isConfigured = !isDemoMode && Boolean(url && key);
const demoGuard = new Proxy(
  {},
  {
    get: () => {
      throw new Error('Supabase non è disponibile durante il collaudo locale.');
    },
  },
) as ReturnType<typeof createClient>;
export const supabase = isDemoMode
  ? demoGuard
  : createClient(url || 'http://127.0.0.1:54321', key || 'local-anon-key', {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    });
